import { action, observable } from "mobx";
import { IActivationJSON } from "../interfaces";
import { PLACE_OF_BIRTH, POB_OTHERS } from "../constants";

export type BusinessScale = "UMI" | "UKE" | "UME" | "UBE";

export class Activation {
  @observable
  businessScale: BusinessScale | null = null;

  @observable
  dob = "";

  @observable
  pob = "";

  @observable
  pobOthers = "";

  @observable
  directorEmail = "";

  @observable
  gender = "";

  @observable
  occupation = "";

  @observable
  selfieUrl = "";

  @observable
  businessPhotoUrl = "";

  @observable
  livenessVerified: boolean = false;

  @observable
  ownerNationality = "";

  @action
  updatePartial(json: Partial<IActivationJSON>) {
    if (json.business_scale)
      this.businessScale = json.business_scale as BusinessScale;
    if (json.dob) this.dob = json.dob!!;
    if (json.pob)
      this.pob = PLACE_OF_BIRTH.includes(json.pob.toUpperCase())
        ? json.pob
        : POB_OTHERS;
    if (json.pob)
      this.pobOthers = PLACE_OF_BIRTH.includes(json.pob.toUpperCase())
        ? ""
        : json.pob;
    if (json.director_email) this.directorEmail = json.director_email;
    if (json.gender) this.gender = json.gender;
    if (json.occupation) this.occupation = json.occupation;
    if (json.business_photo_url)
      this.businessPhotoUrl = json.business_photo_url;
    if (json.liveness_verified) this.livenessVerified = json.liveness_verified;
    if (json.selfie_url) this.selfieUrl = json.selfie_url;
    if (json.owner_nationality) this.ownerNationality = json.owner_nationality;
  }

  static fromJSON(json: IActivationJSON): Activation {
    const activation = new Activation();

    const getPob = (): string => {
      if (!json.pob) return "";

      return PLACE_OF_BIRTH.includes(json.pob.toUpperCase())
        ? json.pob
        : POB_OTHERS;
    };

    const getPobOthers = () => {
      if (!json.pob) return "";

      return PLACE_OF_BIRTH.includes(json.pob.toUpperCase()) ? "" : json.pob;
    };

    activation.businessScale = json.business_scale
      ? (json.business_scale as BusinessScale)
      : null;
    if (json.dob) activation.dob = json.dob;
    if (json.pob) {
      activation.pob = getPob();
      activation.pobOthers = getPobOthers();
    }
    if (json.director_email) activation.directorEmail = json.director_email;
    if (json.gender) activation.gender = json.gender;
    if (json.occupation) activation.occupation = json.occupation;
    if (json.business_photo_url)
      activation.businessPhotoUrl = json.business_photo_url;
    activation.livenessVerified = json.liveness_verified;
    activation.selfieUrl = json.selfie_url || "";
    activation.ownerNationality = json.owner_nationality || "";

    return activation;
  }
}
